import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

export const DashboardIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect x="11.5" y="3.5" width="9" height="9" rx="2" fill="var(--equiply-icon-bg)" />
      <rect x="3.5" y="3.5" width="7" height="7" rx="2" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="2" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="2" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
    </svg>
  ),
);
DashboardIcon.displayName = "DashboardIcon";
